export const styles = `
  body {
    font-family: AbyssEnterpriseSansVF, Arial, sans-serif;
  }
`;
